import { gql } from '@apollo/client'

export const RegisterGuest = gql`
    mutation RegisterGuest($email: String!, $password: String!) {
        registerGuest(email: $email, password: $password)
    }
`

export default RegisterGuest

